import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { ExploreLocal } from "@/components/landing/ExploreLocal";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Features } from "@/components/landing/Features";
import { AppShowcase } from "@/components/landing/AppShowcase";
import { About } from "@/components/landing/About";
import { CTABanner } from "@/components/landing/CTABanner";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#F9F6F0]">
      <Navbar />
      <main>
        <Hero />
        <ExploreLocal />
        <HowItWorks />
        <Features />
        <AppShowcase />
        <About />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
}
